export default __webpack_public_path__ + "static/media/land-parcel.0fc96e0a.svg";